<div class="mb-3 {{to.className}}">
  @if (to.label) {
    <legend class="text-xl text-primary mb-2">{{ to.label }}</legend>
  }
  @if (to.description) {
    <p>{{ to.description }}</p>
  }
  @if (showError && formControl.errors) {
    <div class="alert alert-danger" role="alert">
      <formly-validation-message [field]="field"></formly-validation-message>
    </div>
  }

  <mat-card appearance="outlined">
    @for (row of field.fieldGroup; track row; let i = $index) {
      <div class="flex flex-row justify-between w-full">
        <formly-field class="" [field]="row"></formly-field>
        @if (row.templateOptions.removable !== false) {
          <div class=" text-right">
            <button mat-icon-button type="button" color="warn" matTooltip="Delete row" (click)="remove(i)">
              <mat-icon svgIcon="heroicons_outline:minus-circle"></mat-icon>
            </button>
          </div>
        }
      </div>
    }
  </mat-card>

  <div class="d-flex flex-row-reverse mt-2">
    <button mat-icon-button type="button" color="primary" matTooltip="Add row" (click)="add()">
      <mat-icon svgIcon="heroicons_outline:plus-circle"></mat-icon>
    </button>
  </div>
</div>